import type { MouseEvent as ReactMouseEvent } from "react";

// The element the current mouse press started on. One press at a time, so a
// single slot serves every dialog.
let pressedOn: EventTarget | null = null;

/** Props for a `.modal-overlay` that closes when its backdrop is clicked.
 *  A bare onClick also fires when a press starts inside the dialog — say,
 *  drag-selecting the text in a field — and is released over the backdrop,
 *  because the browser aims that click at their common ancestor. Requiring the
 *  press to start on the backdrop too keeps the dialog open in that case. */
export function backdropClose(close: () => void) {
  return {
    onMouseDown: (e: ReactMouseEvent) => { pressedOn = e.target; },
    onClick: (e: ReactMouseEvent) => {
      if (e.target === e.currentTarget && pressedOn === e.currentTarget) close();
    },
  };
}
